import React from 'react';
import { GenericNotificationPage } from '../genericNotificationPage/genericNotificationPage';

export const UseLargerScreen = (): JSX.Element => {
  return (
    <GenericNotificationPage
      iconUrl="assets/bigBangLab/use-larger-screen.png"
      title="Oops! Your screen is too small."
      subtitle="Please try using a tablet or computer to continue."
    />
  );
};
